export const opepenNFTs = [
 
  {
    id: 'opepen-15969',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/10.png',
    price: '0.22 ETH'
  },
  {
    id: 'opepen-15966',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.35 ETH'
  },
  {
    id: 'opepen-15963',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.41 ETH'
  },
  {
    id: 'opepen-15968',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.18 ETH'
  },
  {
    id: 'opepen-15962',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.29 ETH'
  },
  {
    id: 'opepen-15952',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/43a4f9d0-6f4e-4c25-9f9e-58970ad130bc.png',
    price: '0.44 ETH'
  },
  {
    id: 'opepen-15945',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.13 ETH'
  },
  {
    id: 'opepen-15950',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/10.png',
    price: '0.26 ETH'
  },
  {
    id: 'opepen-15953',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/71398c38-ca18-47b2-8b5f-eb83936f385e.png',
    price: '0.33 ETH'
  },
  {
    id: 'opepen-15940',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmS69kH75fhR98DQoApXgjPt7yY5nbqrJY1kjQ55SGUhBy/Bauhaus%201923.png',
    price: '0.48 ETH'
  },
    
  {
    id: 'opepen-15947',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/4.png',
    price: '0.16 ETH'
  },
  {
    id: 'opepen-15943',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.42 ETH'
  },
  {
    id: 'opepen-15948',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmaU7LHb8dD368UJsocvnBmovb3FhuD7MsJuVW84Va2RZj/CYCLOPS.png',
    price: '0.31 ETH'
  },
  {
    id: 'opepen-15946',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/df80d5e2-3488-462a-9a10-cddf91680b49.gif',
    price: '0.27 ETH'
  },
  {
    id: 'opepen-15941',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/10.png',
    price: '0.39 ETH'
  },
  {
    id: 'opepen-15942',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmQwzkCpFSmAMdMMizJdEanWUkpN8j3HkKeHeKMp3bk9XJ/40-25.png',
    price: '0.21 ETH'
  },
  {
    id: 'opepen-15944',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.36 ETH'
  },
  {
    id: 'opepen-15938',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmThaFkuRZCRpzxuyEUzQ5XxDonsUdNz4QWtYDmKyGcQGf/40-26.png',
    price: '0.47 ETH'
  },
  {
    id: 'opepen-15937',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.14 ETH'
  },
  {
    id: 'opepen-15939',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/56ce3822-2875-499a-b841-3799ca91b730.png',
    price: '0.25 ETH'
  },
  {
    id: 'opepen-15930',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.43 ETH'
  },
  {
    id: 'opepen-15933',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.18 ETH'
  },
  {
    id: 'opepen-15932',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.34 ETH'
  },
  {
    id: 'opepen-15929',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.46 ETH'
  },
  {
    id: 'opepen-15931',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/df80d5e2-3488-462a-9a10-cddf91680b49.gif',
    price: '0.12 ETH'
  },
  {
    id: 'opepen-15928',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.37 ETH'
  },
  {
    id: 'opepen-15927',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.49 ETH'
  },
  {
    id: 'opepen-15935',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/cb1e427a-a101-4219-ae2e-5b6cb56002ac.svg',
    price: '0.24 ETH'
  },
  {
    id: 'opepen-15926',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.11 ETH'
  },
  {
    id: 'opepen-15936',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/10.png',
    price: '0.40 ETH'
  },
  {
    id: 'opepen-15934',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.30 ETH'
  },
  {
    id: 'opepen-15925',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/f213e09d-56bf-44e3-b338-f6e8828a8829.jpeg',
    price: '0.20 ETH'
  },
  {
    id: 'opepen-15922',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmcUn7WoTHRf4VRYVFiPUZ7YMccymAzZaiy7DDoEcrAXgo/40.png',
    price: '0.50 ETH'
  },
  {
    id: 'opepen-15916',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/7da3c197-4354-4833-aaf6-dc220b20b140.png',
    price: '0.15 ETH'
  },
  {
    id: 'opepen-15923',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/f0490fd8-9d8d-450e-a7d8-754aced01a8c.png',
    price: '0.33 ETH'
  },
  {
    id: 'opepen-15921',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/2a6bc111-bb19-41e2-973a-cedb96d5333b.png',
    price: '0.28 ETH'
  },
  {
    id: 'opepen-15909',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/5.png',
    price: '0.45 ETH'
  },
  {
    id: 'opepen-15924',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.19 ETH'
  },
  {
    id: 'opepen-15915',
    name: 'Opepen Edition',
    image: 'https://opepenai.nyc3.digitaloceanspaces.com/images/814085bc-75d5-4a5d-8b4c-c95bb7e7570e.png',
    price: '0.38 ETH'
  },
  {
    id: 'opepen-15918',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVALNnA1dDnnN2wy4epxqdN7A5Bb2Zq1yR1NsdMCKKxf2/40-15.png',
    price: '0.23 ETH'
  },
  {
    id: 'opepen-15919',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/10.png',
    price: '0.17 ETH'
  },
  {
    id: 'opepen-15912',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/5.png',
    price: '0.32 ETH'
  },
  {
    id: 'opepen-15914',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.45 ETH'
  },
  {
    id: 'opepen-15910',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.28 ETH'
  },
  {
    id: 'opepen-15904',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.41 ETH'
  },
  {
    id: 'opepen-15917',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/10.png',
    price: '0.35 ETH'
  },
  {
    id: 'opepen-15901',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.22 ETH'
  },
  {
    id: 'opepen-15920',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.16 ETH'
  },
  {
    id: 'opepen-15902',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.31 ETH'
  },
  {
    id: 'opepen-15899',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/4.png',
    price: '0.44 ETH'
  },
  {
    id: 'opepen-15903',
    name: 'Opepen Edition',
    image: 'https://api.opepen.art/v1/opepen/images/a947957d-1540-47be-b9a5-a03d35521c44/render',
    price: '0.27 ETH'
  },
  {
    id: 'opepen-15895',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmT4pDenXgm3NMiAXpCxyWmx8teYsjtsXhYsxK7mGNAJxp/mint.png',
    price: '0.39 ETH'
  },
  {
    id: 'opepen-15891',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/5.png',
    price: '0.21 ETH'
  },
  {
    id: 'opepen-15894',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/20.png',
    price: '0.36 ETH'
  },
  {
    id: 'opepen-15898',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.47 ETH'
  },
  {
    id: 'opepen-15888',
    name: 'Opepen Edition',
    image: 'https://ipfs.io/ipfs/QmVXvZ5Sp6aSDBrWvtJ5gZ3bwNWRqqY3iPvyF8nveWj5HF/40.png',
    price: '0.33 ETH'
  }


];